import React from 'react';

import { SettingsSaveBar } from './SettingsSaveBar';
import { SettingsSaveBarContext } from './SettingsSaveBarContext';

/**
 * Where the save bar shows: the page's top right. Sticky and zero-height so it
 * stays in view while the page scrolls without pushing the column down.
 */
export const SettingsSaveBarSlot = () => {
  const saveBar = React.useContext(SettingsSaveBarContext);
  if (!saveBar) return null;

  return (
    <div className="sticky top-0 z-10 h-0">
      <div className="absolute top-4 right-6">
        <SettingsSaveBar {...saveBar} />
      </div>
    </div>
  );
};
